/**
 * Primary controller for viewing a single story at /stories/:id
 * @author Ryan Gladstone
 */

function StoryController(
  $scope,
  $transition$,
  $translate,
  featureFlag,
  Story
) {
  $scope.story = {
    loading: true
  };

  $scope.detailedView = true;
  const { id } = $transition$.params();
  $scope.id = decodeURIComponent(decodeURIComponent(id));

  // true === hidden, obviously
  $scope.togglePitchForm = true;

  if (!$scope.id) {
    $scope.story.loading = false;
    $scope.story.error = {
      type: 'danger',
      msg: $translate.instant('PLEASE_PROVIDE_STORY_ID')
    };
  } else {
    Story.get($scope.id)
      .then((storyObj) => {
        $scope.story.loading = false;
        $scope.story = storyObj;
        $scope.story.formattedDates = storyObj.getFormattedDates($scope.story);
        $scope.pitchesForPanel = {
          platforms: $scope.story.pitches,
          publications: $scope.story.publicationPitches
        };
      }, (response) => {
        $scope.story.loading = false;

        // handle rejected promise here
        if (response && response.data && response.data.error) {
          const msg = response.data.error === 'The requested story was not found'
            ? $translate.instant('INCORRECT_STORY_ID_ERROR', { id: $scope.id })
            : response.data.error;
          $scope.story.error = { type: 'danger', msg };
        } else {
          $scope.story.error = { type: 'danger', msg: response };
        }
      });
  }

  $scope.setCollections = (collections) => {
    $scope.story.collections = collections;
  };
}

const arr = [
  '$scope',
  '$transition$',
  '$translate',
  'featureFlag',
  'Story',
  StoryController
];

export default function (ngModule) {
  ngModule.controller('StoryController', arr);
}
